import tools from '@/sui/data/sheets/edit/tools'
import fields from '@/sui/data/sheets/edit/fields'
import go from '@/gojs/go'

const intubFields = {
  std: {
    intubated: fields.intubated,
    intubStart: fields.intubStart,
    reintubated: fields.reintubated,
    intubEnd: fields.intubEnd
  }
}

const prefixes = ['bact', 'sep']
prefixes.forEach(
  p => {
    intubFields[p] = {}
    for (let f in intubFields.std) {
      intubFields[p][f] = `${p}${intubFields.std[f]}`
    }
  }
)

const select = (function () {
  function build (t) {
    return {
      intub: tools.equals(intubFields[t].intubated, 1)
    }
  }

  return {
    std: build('std'),
    bact: build('bact'),
    sep: build('sep')
  }
})()

const ecmo = tools.cfg.list(fields.ecmo, 'ECMO', go.fields.reaECMO)

const intubated = (function () {
  function build (t) {
    return tools.cfg.list(
      intubFields[t].intubated, 'Intubation / Trachéotomie',
      go.fields.yesNoUnknown
    )
  }

  return {
    std: build('std'),
    bact: build('bact')
  }
})()

const reintubated = (function () {
  function build (t) {
    return tools.cfg.list(
      intubFields[t].reintubated, 'Réintubation', go.fields.yesNoUnknown,
      { sel: select[t].intub }
    )
  }
  return {
    std: build('std'),
    bact: build('bact'),
    sep: build('sep')
  }
})()

const intubStart = (function () {
  function build (t) {
    return tools.cfg.date(
      intubFields[t].intubStart, `d'intubation / trachéotomie`,
      { sel: select[t].intub }
    )
  }

  return {
    std: build('std'),
    bact: build('bact'),
    sep: build('sep')
  }
})()

const intubEnd = (function () {
  function build (t) {
    return tools.cfg.date(
      intubFields[t].intubEnd, `de fin d'intubation / trachéotomie`, {
        op: true, sel: select[t].intub
      }
    )
  }
  return {
    std: build('std'),
    bact: build('bact'),
    sep: build('sep')
  }
})()

export default {
  select,
  ecmo,
  intubated,
  reintubated,
  intubStart,
  intubEnd,
  fields: intubFields
}
